import React from 'react';
import IconAction from '../IconAction';

export default function IconActionButton({ onClick, ...props }) {
  return (
    <IconAction
      {...props}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        onClick?.(event);
      }}
    />
  );
}
